import React from 'react'; 
import PropTypes from 'prop-types';

//Components
import Accordion from 'react-bootstrap/lib/Accordion';
import Faq from './Faq';
import Panel from 'react-bootstrap/lib/Panel';
import $ from 'jquery';

class MainContent extends React.Component {
    constructor() {
        super();
        this.state = { isFaqOpen: false };
    }

    toggleFAQ = () => {
        this.setState({
            isFaqOpen: !this.state.isFaqOpen
        });
    }
    scrollToFAQ = () => {
        $('body, html').animate({ scrollTop: $('.faqSection').offset().top }, 500);
        this.setState({ isFaqOpen: true });
    }
    render() {
        if (!window.osa || !window.osa.lookup) return null;
        const p = this.props;
        const common = window.osa.lookup && window.osa.lookup.common;
        const message = common && common.mainInfo;
        const faqList = window.osa.faq;
        const faqItem = faqList.find(x => x.Name === p.activePageTitle);
        const stepFaqList = faqList && faqItem ? faqItem.FAQs : [];
        let faq = null;
        //Create FAQ header with those OPEN-CLOSE button 
        if (common && common.showFAQ == 'true') {
            const faqHeader = (
                <div className="faqHeader w100">
                    <i className="fa fa-question-circle text-blue-light" />
                    &nbsp; Need help with this page?
                {!this.state.isFaqOpen ?
                        <span className="openCloseButton">OPEN <i className="fa fa-chevron-down text-orange" /></span>
                        :
                        <span className="openCloseButton">CLOSE <i className="fa fa-chevron-up text-orange" /></span>
                    }
                </div>);
            //Add FAQ to the end of steps
            faq = (
                <Panel expanded={this.state.isFaqOpen} collapsible header={faqHeader} onSelect={this.toggleFAQ} className="panel-default step-title">
                    <Faq faqList={stepFaqList} />
                </Panel>);
        }
        return (
            <div>
                <div dangerouslySetInnerHTML={{ __html: common && common.serviceText }} />
                 
                    <div dangerouslySetInnerHTML={{ __html: message }} style={{marginBottom: '20px'}} />
                
                <div>
                    {/* <div className="panel-info-navigation">
                    <div className="panel-info-navigation-body">*/}
                    <b>Important:</b> If you would like to change the information entered in a previous step, please click the back link at the bottom of the each step. If you navigate away from this page (e.g. by clicking the back button in your browser), you will lose all of the information you have entered.
                 {/* </div>
               </div> */}
                </div>
                <div className="text-danger" style={{ marginTop: '10px', marginBottom: '10px' }}>
                    <span className={{ fontSize: '16px' }}>*</span>
                    <span style={{ fontSize: '14px' }}>Required fields</span>
                    <span className="help-faq">
                        <a onClick={this.scrollToFAQ}><i className="fa fa-question-circle" /></a>
                        <a onClick={this.scrollToFAQ} className="fortis-link" style={{ fontSize: '15px' }}> Help FAQ</a>
                    </span>
                </div>
                <Accordion activeKey={p.activeIndex} >
                    {p.steps}
                </Accordion>
                <div className="faqSection">
                    {faq}
                </div>
            </div>
        );
    }
}

MainContent.propTypes = {
    message: PropTypes.string,
    activeIndex: PropTypes.number,
    steps: PropTypes.array.isRequired,
    activePageTitle: PropTypes.string
};
export default MainContent;